import React from 'react';
import TeaserPlaceholder from './TeaserPlaceholder';
import { LinkEntry } from '../helper/interfaces';
import { getSpecificLink } from '../helper/link';
import { LinkType } from '../helper/enums';

interface TeaserPlaceholderListProps {
  autoContentSize: number;
  teasersLength: number;
  links: LinkEntry[];
}

const TeaserPlaceholderList: React.FC<TeaserPlaceholderListProps> = ({ autoContentSize, teasersLength, links }) => {
    const selfLink = getSpecificLink(links, LinkType.Self);
    if (autoContentSize <= 0 || !selfLink) {
        return null;
    }

    return (
        <>
        {teasersLength == 0 &&
        <>
        {Array.from({ length: autoContentSize }).map((_, index) => (
            <TeaserPlaceholder key={`auto-content-size-${index}`} index={index} />
        ))}
        </>
        }
        </>
    );
};

export default TeaserPlaceholderList;
